import api from './api';

export const getPaidRequests = async (dateValue) => {
    try {
        const obj = { dateValue };
        const response = await api.post('/api/overtime/getPaidRequests', obj);
        return response.data;
    } catch (error) {
        return {};
    }
};